export default __webpack_public_path__ + "static/media/list-filled.ae0148a2.svg";